import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import {
    DKLabel,
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    showAlert,
    DKCheckMark,
    DKInput
} from "deskera-ui-library";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { COMPANY_DATE_FORMATS, INPUT_TYPE } from "../../constants/Constant";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import moment from "moment";
import { OvertimeService } from "./OvertimeService";
import OvertimeApiService from "../../services/OvertimeService";
import { getOvertimeRowData, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import { DEFALUT_EFFECTIVE_DATE, OVERTIME_ACTIVATE_POPUP_FORM, POLICY_STATUS } from "./OvertimeConstants";
import i18next from "i18next";
import Popup from "../common/Popup";
import Utility, { deepClone } from "../../utility/Utility";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";
import DKInputDateTime from "../common/DKInputDateTime";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
 function OvertimeList (props) {
    const history = useHistory();
    let dateFormat = COMPANY_DATE_FORMATS.filter(c=>c.label==TenantService.get(TENANT.DATE_FORMAT))
        
    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        dateFormat = dateFormat[0]?.value;
        getOvertimePolicy();
        setOvertimeData({
            columnData:parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_OVERTIME_LIST)), TABLES.PEOPLE_OVERTIME_LIST),
            rowData: [],
        filter: [],
        originalData: []
        })
    }, []);
    const getOvertimePolicy =(config)=>{
        showLoader()
        OvertimeApiService.getOvertimePolicy(config).then(res=>{
            if(res.data) {
                setOvertimeData({
                    columnData:parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_OVERTIME_LIST)), TABLES.PEOPLE_OVERTIME_LIST),
                    rowData: getOvertimeRowData(res.data),
                filter: [],
                originalData: []
                })
            }
            if(res.filterConfig) {
                setCurrentPage(parseInt(res?.filterConfig?.page));
                setTotalPageCount(res.filterConfig.totalPage);
            }
        },error=>{
            showToast("Internal Server Error", TOAST_TYPE.FAILURE)
        }).finally(()=>{
            removeLoader()
        })
    }
    const [overtimeData, setOvertimeData] = useState({
        columnData:  parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_OVERTIME_LIST)), TABLES.PEOPLE_OVERTIME_LIST),
        rowData: [],
        filter: [],
        originalData: []
    });
    const [showActivatePop,setShowActivatePop]=useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [activePopupData, setActivePopupData] = useState({
        effectiveFrom: null,
        remark:''
    })
    const [otActivatePopup, setOtActivatePopup] = useState(deepClone(OVERTIME_ACTIVATE_POPUP_FORM));
    const [canActive, setCanActive] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [reload, setReload] = useState(false);
     const onRowEdit = (data) => {
         const isShift = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
         if (isShift) {
             OvertimeService.setOvertimeData(data);
             RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_SETTING + "/" + data.rowData.data.id);
         } else {
            OvertimeService.setOvertimeData(null);
            showAlert("Please Enable Shift Management","You have enable Shift Management for edit Overtime Policy.");
         }
     }
    const onView = (data)=>{
        OvertimeService.setOvertimeData(data);
        RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_SUMMARY+"/"+data.rowData.data.id);
    }
    const onRowDelete = (data)=>{
        const isShift = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
        if (!isShift) {
            showAlert("Please Enable Shift Management","You have enable Shift Management for delete Overtime Policy.");
            return;
        }
        let isEmployeeAssign = false;
        let ids = data.map(d=>d.data.id)
        if(isEmployeeAssign) {
            
            showToast(i18next.t('EMPLOYEE_EXIST'), TOAST_TYPE.FAILURE);
            return;
        }
        let payload = {
            ids:ids,
            "forcedDelete": true
        }
        const buttons = [
            {
              title: "Cancel",
              className: "bg-gray1 border-m",
              onClick:()=>{
                getOvertimePolicy(OvertimeApiService.OTConfig);
              }
            },
            {
              title: "Delete",
              className: "bg-red text-white ml-r",
              onClick: () => {
                deleteOverTime(payload);
              },
            },
          ];
        showAlert(
            "Delete Action?",
            `Deleting this action will delete it permanently. Do you want to delete ?`,
            buttons
          );
        
    }
    const deleteOverTime=(payload)=>{
        const isShift = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
        if (!isShift) {
            showAlert("Please Enable Shift Management","You have enable Shift Management for delete Overtime Policy.");
            return;
        }
        OvertimeApiService.delete(payload).then(res=>{
            if(res && res.status &&  res.status == 'FAILED') {
                showToast(res.message,TOAST_TYPE.FAILURE)
            } else {
                showToast("Overtime Policy is deleted successfully.",TOAST_TYPE.SUCCESS);
            }
            getOvertimePolicy(OvertimeApiService.OTConfig);
            
        },error=>{
            if(error && error.message) {
                showToast(error.message, TOAST_TYPE.FAILURE);
            } else {
                showToast(error.message, TOAST_TYPE.FAILURE)
            }
            getOvertimePolicy(OvertimeApiService.OTConfig);
        })
    }
    const onRowUpdate = (data) => {
        setSelectedData(data);
        if(data["columnKey"] == "status") {
            let rowUpdateData = data.rowData.data;
            rowUpdateData['status'] = data.rowData.status[0];
            if(rowUpdateData['status'] == POLICY_STATUS.ACTIVE) {
                setActivePopupData({
                    effectiveFrom: (!Utility.isEmpty(rowUpdateData?.effectiveFrom) && rowUpdateData.effectiveFrom != DEFALUT_EFFECTIVE_DATE) ? rowUpdateData.effectiveFrom:null ,
                    remark: rowUpdateData.remark
                })
                setShowActivatePop(true);
                
            } else {
                rowUpdateData = {
                    ...rowUpdateData,
                    effectiveFrom: DEFALUT_EFFECTIVE_DATE,
                    activated: (rowUpdateData['status'] == POLICY_STATUS.ACTIVE) ? true:false,
                    employees: data.rowData?.data?.employees ?  (data.rowData.data.employees.map(r=>r.employeeId)):[]
                }
                updateStatus({...rowUpdateData})
            }
        }
    }
    const updateStatus = (data) =>{
        showLoader()
        OvertimeApiService.saveOvertimePolicy(data, data?.id).then(res=>{
            getOvertimePolicy(OvertimeApiService.OTConfig);
            showToast(i18next.t("OT_STATUS_UPDATE"),TOAST_TYPE.SUCCESS);
        },error=>{
            if(error && error.code == 2) {
                showToast(error.message? error.message : i18next.t("INTERNAL_SERVER_ERROR"),TOAST_TYPE.FAILURE);
                getOvertimePolicy(OvertimeApiService.OTConfig);
            } else {
                showToast(i18next.t("INTERNAL_SERVER_ERROR"),TOAST_TYPE.FAILURE)
            }
        }).finally(()=>{
            setSelectedData(null);
            setCanActive(false);
            setShowActivatePop(false);
            removeLoader()
        })
    }
     const checkIfSameUserAssignToPolicy = (selectedEmployeeIds,data) => {
         if (selectedEmployeeIds.length != 0) {
             OvertimeApiService.getOvertimeByEmployee({ employeeIds: selectedEmployeeIds }).then(res => {
                 if (res && res.status == 'FAILED') {
                    onEmploeeNotInUse(data,POLICY_STATUS.ACTIVE);
                 } else if (res && res.data) {
                     let list = res.data;
                     const currentOtID = selectedData?.rowData?.data?.id
                     if (currentOtID) {
                         list = list.filter(l => l.id != currentOtID);
                     }
                     if (list.length != 0) {
                         showToast(i18next.t('EMPLOYEE_EXIST'), TOAST_TYPE.FAILURE);
                         setShowActivatePop(false);
                         setSelectedData(null);
                         setCanActive(false);
                         getOvertimePolicy(OvertimeApiService.OTConfig);
                     } else if (list.length == 0) {
                         onEmploeeNotInUse(data, POLICY_STATUS.ACTIVE);
                     }
                 } else {
                    onEmploeeNotInUse(data,POLICY_STATUS.ACTIVE);
                 }
             }, error => {

             })
         } else {
            onEmploeeNotInUse(data,data.rowData.status[0]);
         }
     }
     const onEmploeeNotInUse=(data,status) =>{
        let rowUpdateData = data.rowData.data;
        rowUpdateData['status'] = status;
        rowUpdateData = {
            ...rowUpdateData,
            activated: (rowUpdateData['status'] == POLICY_STATUS.ACTIVE) ? true:false,
            employees: data.rowData?.data?.employees ?  (data.rowData.data.employees.map(r=>r.employeeId)):[]
        }
        if(activePopupData?.effectiveFrom) { 
            rowUpdateData['effectiveFrom'] = moment(activePopupData?.effectiveFrom).format();
            rowUpdateData['remark'] = activePopupData?.remark
        }
        updateStatus({...rowUpdateData})
     }
     const getActivatePopup=()=> {
        return(
            <>
            {showActivatePop && <Popup popupClass={"popup-overflow"} onClose={() => setShowActivatePop(false)}>
                    <div className="parent-width">
                        <div className="d-flex">
                            <DKLabel text={"Activating the Policy"} className="fs-l fw-b" />
                            <div className="ml-auto d-flex">
                                <DKButton
                                    title={i18next.t("CANCEL")}
                                    className="border-radius-m bg-gray1 border-m"
                                    onClick={() => {
                                        setShowActivatePop(false);
                                        setSelectedData(null);
                                        setCanActive(false);
                                        getOvertimePolicy(OvertimeApiService.OTConfig);
                                    }}
                                />
                                <DKButton
                                    title={i18next.t("Activate")}
                                    className="bg-app text-white ml-m"
                                    onClick={() => {
                                        const data = selectedData;
                                        const employeeIds = data?.rowData?.data?.employees ?  (data.rowData.data.employees.map(r=>r.employeeId)):[]
                                        if(activePopupData && Utility.isEmpty(activePopupData.effectiveFrom)){
                                            setCanActive(true);
                                            return;
                                        }
                                        checkIfSameUserAssignToPolicy(employeeIds,data);
                                    }}
                                />

                            </div>
                        </div>
                        <div className="row row-responsive flex-wrap pt-m">
                            {otActivatePopup.map((subField, subIndex) => {
                                return <div className="parent-width">{renderFormField(subField, subIndex)}</div>
                            })}
                        </div>

                    </div>
                </Popup>}
            </>
        )
    }
    const getFieldValue =(obj)=>{
        switch(obj.key) {
            case 'effectiveFrom':
                if(!Utility.isEmpty(activePopupData[obj.key])) {
                    return new Date(activePopupData[obj.key])
                } else {
                    return null
                }
            default:
                return activePopupData[obj.key]
        }
    }
    const renderFormField=(obj,index)=>{
        return (
            <>
            <DKInput
                    className={` ${obj.direction == INPUT_VIEW_DIRECTION.HORIZONTAL ? "mb-l ":"p-v-s p-h-l mb-l"}`}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={obj['canValidate'] || canActive }
                    onChange={(value) => {
                        const data = deepClone(activePopupData);
                        data[obj.key] = value
                        setActivePopupData({
                            ...data
                        })
                    }}
                    validator={(value) => {
                        
                        if(obj.columnCode == "employees") {
                            return obj.isValid;
                        } else if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value.trim());
                            return regex.test(value.trim());
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value)) {
                            obj.isValid = false
                            return false;
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return (obj && obj.name) ? obj.name : obj;
                    }}
                    displayKey="name"
                    dropdownConfig={{
                        checkMarkColor: "bg-app",
                        className: "",
                        style: {},
                        multiSelect: obj.multiSelect,
                        data: obj.options,
                        allowSearch:
                        obj.options && obj.options.length > 6 ? true : false,
                        searchableKey: "name",
                        button: (!Utility.isEmpty(obj.buttonConfig) && obj.options.length == 0 && false)
                            ? {
                                title: obj.buttonConfig.title,
                                onClick: (e) => {
                                  RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_RATE_CONFIG)
                                },
                                className: obj.buttonConfig.className,
                              }
                            : false,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj?.name ? obj.name: obj}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly || ( obj.direction != INPUT_VIEW_DIRECTION.HORIZONTAL)}
                    tooltip={{
                        content: obj.tooltipText,
                        className: "warning-tooltip-prop",
                      }}
                />
            </>
        )
    }
    
     function getGiroGrid() {
        return (
            <>
            <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_OVERTIME_LIST}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_OVERTIME_LIST]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={PermissionUtils.hasAccess(MODULE.OVERTIME_POLICY, ACTION.EDIT)}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={overtimeData}
                        filter={overtimeData}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        addButtonConfig={[
                            {
                                title: `+ Create ${TABLE_DISPLAY_NAME[TABLES.PEOPLE_OVERTIME_LIST]}`,
                                className: "bg-app text-white ml-s",
                                onClick: () => {
                                    OvertimeService.setOvertimeData(null);
                                    const isShift = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
                                    if(isShift) {
                                        RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_SETTING)
                                    } else {
                                        showAlert("Please Enable Shift Management","You have enable Shift Management for adding Overtime Policy.");
                                    }
                                },
                              }
                        ]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            onRowDelete(data)
                        }}
                        onSelection={(selection) => {
                            // this.selection = (selection);
                        }}
                        onRowEdit={onRowEdit}
                        allowBulkOperation={true}
                        // dateFormat={dateFormat}

                        onCancelContext={() => {
                            // this.onContextCancel();
                        }}
                        // contextMenu={false}
                        onRowClick={(data) => {
                            // this.onRowClick(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            
                            // this.grid.gridActions.currentPage = requestedPageNumber
                            const config = {
                                ...OvertimeApiService.OTConfig,
                                currentPage:requestedPageNumber
                            }
                            getOvertimePolicy(config)
                        }}
                        // isMenuVisible={false}
                        onView={onView}
                        onColumnShift={()=>getOvertimePolicy(OvertimeApiService.OTConfig)}
                        module={MODULE.OVERTIME_POLICY}
                    />
                </div>
            </div>
                    {getActivatePopup()}
            </>
        )
    }
    return (
        <Fragment>
            {/* <DKLabel className="fw-m fs-l" text="Overtime"/> */}
            {getGiroGrid()}
        </Fragment>
    )
}
export default OvertimeList